
import { createContext } from "react";

import { GetUserGroupsConfigResponse } from "../../api/dtos/dtos";
import useGetUserGroupsConfig from "../../hooks/data/useGetUserGroupsConfig";


export interface IUserGroupsContext extends Omit<ReturnType<typeof useGetUserGroupsConfig>, 'data' | 'total' | 'offset'> {
    data?: GetUserGroupsConfigResponse
}

export const UserGroupsContext = createContext<IUserGroupsContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default UserGroupsContext;